module.exports = __webpack_public_path__ + "static/media/select.490e86fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/select.png
// module id = 897
// module chunks = 7